export default {
    addBreakToString: (string: string) => {
        return string?.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,'$1' + '<br />' + '$2') || string
    },
    parseStringToHTML: (string: string) => {
        if (typeof window === 'undefined') return string
        const doc = new DOMParser().parseFromString(string, 'text/html')
        return doc.documentElement.textContent
    },
    parseStringToObjectHTML: (text: any) => {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = text
        return tempDiv
    },
    parseHTMLToString: (html: string = '') => html?.replace(/<\/?[^>]+(>|$)/g, '')
}